import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect } from "react";

const theme = localStorage.getItem("brandColor");

const topicRiskScoreDetailsRows = [
    { id: 1, label: "Topic Name", field: "cuzdesc_topicdesc" },
    { id: 2, label: "Location", field: "locationdesc" },
    { id: 3, label: "First Period", field: "firstperiod" },
    { id: 4, label: "First Score", field: "firstscore" },
    { id: 5, label: "Previous Period", field: "previousperiod" },
    { id: 6, label: "Previous Score", field: "previousscore" },
    { id: 7, label: "Latest Period", field: "latestperiod" },
    { id: 8, label: "Latest Score", field: "latestscore" },
    { id: 9, label: "% Increase (Decrease)", field: "pctchange" },
    { id: 10, label: "Risk Change", field: "riskchange" },
];

const StyledButton = styled.button`
    background: ${theme};
    width: 200px;
    border-radius: 30px;
    height: 45px;
    text-align: center;
    color: white;
    font-size: 16px !important;
    font-weight: 500;
    border-color: none;
    border: none;
    margin-top: 25px;
    padding: 5px 10px;
`;

const trStyle = {
    height: '40px'
}

const tdStyle = {
    fontWeight: 500,
    fontSize: '0.875rem'
};

const TopicRiskScoreDetails = () => {
    const history = useHistory()
    const location = useLocation();
    const state = location.state;
    console.log(state)
    useEffect(() => {
        if (!state) {
        history.goBack();
    }
    }, [state, history])

    if (!state) return null;

    return (      
        <>
            <div className="container">
                <div className="text-center">
                    <StyledButton
                        onClick={() => {
                            history.goBack()
                        }}
                    >
                    Exit
                    </StyledButton>
                </div>                    
                <div className="mt-4">                    
                    <table style={{ height: "auto", width: "50%", margin: 'auto' }}>
                        <thead>
                            <tr style={{...trStyle, background: theme, borderRadius: '4px'}}>
                                <th style={{color: '#fff', ...tdStyle}} className="text-center" colSpan="2">Topic Risk Score Details</th>
                            </tr>   
                        </thead>
                        <tbody>
                            {
                                topicRiskScoreDetailsRows.map((x) => {
                                    return (
                                        <tr key={x.id} style={{...trStyle, borderBottom: '1px solid rgba(224, 224, 224, 1)'}}>
                                            <td className="p-0 w-50" style={tdStyle}>{x.label}:</td>
                                            <td className="p-0 w-50" style={tdStyle}>{state[x.field]}</td>
                                        </tr>
                                    )
                                })
                            }
                            
                        </tbody>
                    </table>
                    {/* <div style={{ height: "auto", width: "75%", margin: 'auto' }} className={classes.root}>
                        <DataGrid
                            sx={{
                                ".MuiDataGrid-columnHeaders": {
                                    backgroundColor: theme,
                                },
                                "&.MuiDataGrid-root": {
                                    border: "none",
                                },
                            }}
                            getRowId={(r) => r.id}
                            autoHeight      
                            onRowClick={(params) => {                                    
                                history.push(`/topic_completed_by_location/${params.row.topicid}`);
                            }}                       
                            rows={completedTopics}                                
                            id="_id"                     
                            columns={completedTopicsColumns} 
                            hideFooterPagination={true}                       
                        />
                    </div> */}
                </div>                               
            </div>
        </>
    );
}

export default TopicRiskScoreDetails